<app-base-outbox-messages
[modelWithPagination]="modelWithPagination$"
[items]="items$"
[getTableDataApiMethodName]="getTableDataApiMethodName"
[isResellerType]="true"
[pageTitle]="pageTitle"
pageId="app-resellers-outbox-messages"
[pageTagName]="tagName"
[excelType]="excelType"
>
</app-base-outbox-messages>
